import React, { useEffect, useRef } from "react";
import "./pricing.css";
import { createCheckoutSession, handleUpgrade } from "./stripeFunctions";

const PlanCard = ({
  plan,
  planNo,
  currentPlan,
  hasTrialTaken,
  isTrialPlan,
  queryPlan,
  setLoading,
}) => {
  const upgradeRef = useRef(null);
  console.log({
    plan,
    planNo,
    currentPlan,
    hasTrialTaken,
    isTrialPlan,
    queryPlan,
    setLoading,
  });
  useEffect(() => {
    // console.log({ queryPlan, planNo, currentPlan })
    if (queryPlan && queryPlan === planNo && upgradeRef.current) {
      // console.log({PlanuserId: localStorage.getItem("userid")})
      const newUrl = `${window.location.origin}${window.location.pathname}`;
      /* modify the browser's history state and update the URL displayed in the address bar 
          so that when back button is clicked in stripe checkout page, it will redirect to the pricing page without query params. 
          If we don't clear the history state, then the user will be redirected to the checkout page again after he clicks back button of the browser.
      */
      window.history.replaceState({}, document.title, newUrl);
      upgradeRef.current.click();
    }
  }, [queryPlan, upgradeRef]);

  return (
    <div
      className="planCard"
      style={{ border: currentPlan === planNo ? "2px solid #00B87C" : "none" }}
    >
      {currentPlan === planNo && (
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <span className="currentPlanText">
            Current {isTrialPlan ? "Trial" : ""} Plan
          </span>
        </div>
      )}
      <h1 className="planTitle">{plan?.name}</h1>

      <h3 className="planTitle planPrice">
        ${plan?.price}{" "}
        <span style={{ fontSize: "0.8rem" }}>/ {plan?.subscription}</span>
      </h3>
      <p>{plan?.domain} Domains' backlinks tracking</p>
      <p>{plan?.bklCrawledPerMonth} backlinks crawled per month</p>
      <p>{planNo >= 2 ? "✔️" : "❌"} Index checking on all added link</p>
      {/* <p>
        {planNo >= 2 ? "✔️" : "❌"} New backlinks discovery of added domains
      </p> */}
      {currentPlan < planNo && (
        <>
          {planNo > 1 && (
            <button
              className="upgradeBtn"
              ref={upgradeRef}
              onClick={() => {
                setLoading(true);
                handleUpgrade(plan.priceId, setLoading);
              }}
            >
              Upgrade Now
            </button>
          )}
          {/* {planNo > 1 && currentPlan === 1 && !hasTrialTaken && (
            <p
              className='trial'
              onClick={() => createCheckoutSession(plan.priceId, true)}
            >
              <span>
                Start 15 days Trial
              </span>
            </p>
          )} */}
        </>
      )}
      {/* {planNo > 1 && currentPlan === planNo && isTrialPlan && (
        <button
          className='upgradeBtn'
          onClick={() => {
            endUserTrail();
          }}
        >
          Upgrade Now
        </button>
      )} */}
    </div>
  );
};

export default PlanCard;
